module.exports = __webpack_public_path__ + "img/IMG-20190918-WA0010.b36c78d0.jpg";